import { Injectable } from '@angular/core';
import { ApiService } from '@cakeiteasy/web-utils';
import { ILocationSearchItem } from '../../ui/components/ui-location-search-bar/ui-location-search-bar.component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class KeywordsFetcherService {
  constructor(private _api: ApiService) {
  }

  public getStoreKeywords(countryCode: string, query: string): Observable<ILocationSearchItem[]> {
    return this._api.get('api.common',
      'keywords', null, {
        params: {
          countryCode,
          query
        }
      })
      .pipe(map((results) => {
        return results.map((keyword) => {
          if (keyword.postNumber) {
            keyword.label = keyword.postNumber + ' ' + (keyword.name || keyword.placeName);
            keyword.postNumber = null;
          }

          return keyword;
        });
      }));
  }
}
